<template>
<form>
    <h3>Section Five - Recruitment Information</h3>
    <h4>Which Health Career Pathway/s are you interested in? (mark all that apply)</h4>
    <div class="cb-box">
        <t2-checkbox @change="updateReady" v-model="$parent.rec.PathwayMedicine" label="Medicine" />
        <t2-checkbox @change="updateReady" v-model="$parent.rec.PathwayPharmacy" label="Pharmacy" />
        <t2-checkbox @change="updateReady" v-model="$parent.rec.PathwayNursing" label="Nursing" />
        <t2-checkbox @change="updateReady" v-model="$parent.rec.PathwayHealthSciences" label="Health Sciences" />
        <t2-checkbox @change="updateReady" v-model="$parent.rec.PathwayOptometry" label="Optometry" />
        <t2-checkbox @change="updateReady" v-model="$parent.rec.PathwayMedicalImaging" label="Medical Imaging" />
        <t2-checkbox @change="updateReady" v-model="$parent.rec.PathwayUnsure" label="Unsure" />
        <t2-checkbox @change="updateReady" v-model:otherValue="$parent.rec.PathwayOtherSpecify" v-model="$parent.rec.PathwayOther" other="Specify" label="Other" />
    </div>
    <h4>How did you hear about Pacific Health Wayfinders?</h4>
    <div class="cb-box">
        <t2-checkbox @change="updateReady" v-model="$parent.rec.HearAboutSchool" label="School" />
        <t2-checkbox @change="updateReady" v-model="$parent.rec.HearAboutFamilyFriends" label="Family/ Friends" />
        <t2-checkbox @change="updateReady" v-model="$parent.rec.HearAboutSocialMedia" label="Social Media" />
        <t2-checkbox @change="updateReady" v-model="$parent.rec.HearAboutExpo" label="Expo" />
        <t2-checkbox @change="updateReady" v-model:otherValue="$parent.rec.HearAboutOtherSpecify" v-model="$parent.rec.HearAboutOther" other="Specify" label="Other" />
    </div>
    <br/>
        <h4 v-if="$parent.incompleteTabs.length==0">By submitting this form, I declare that the information is true and correct and that I have read and understood the University of Auckland <a href="https://www.auckland.ac.nz/en/privacy.html" target="_blank">Privacy policy.</a></h4>
        <h4 v-else>Submit is disabled because section {{$parent.incompleteTabs.join(",")}} {{$parent.incompleteTabs.length>1?"are":"is"}} not complete.</h4>
    <footer>
        <button @click.prevent="$parent.prevTab">Back</button>
        <button v-if="!ready" disabled>Submit</button>
        <button v-else @click.prevent="$parent.submit()">Submit</button>
    </footer>
</form>
</template>

<script>
import t2Checkbox from '@/components/t2-checkbox.vue'
export default {
    name:"section 5",
    components:{t2Checkbox},
    data: function (){return {
        ready: false
    }},
    methods:{
        updateReady: function(){
            if (this.$parent.incompleteTabs.length>1)
                this.ready = false;
            else if (this.$parent.incompleteTabs.length==1 && this.$parent.incompleteTabs[0]!="5")
                this.ready = false;
            else
                this.ready = this.allGood();
            if (this.ready)
                this.$parent.incompleteTabs = [];
            else {
                if (this.$parent.incompleteTabs.findIndex(u=>u==5)==-1)
                    this.$parent.incompleteTabs.push(5);
            }
        },
        allGood: function(){
        let pathway = ["Medicine","Pharmacy","Nursing","HealthSciences","Optometry","MedicalImaging","Unsure","PathwayOther"].filter(
                u=>this.$parent.rec["Pathway"+u]
            );
        let hear = ["School","FamilyFriends","SocialMedia","Expo","Other"].filter(
                u=>this.$parent.rec["HearAbout"+u]
            );
        return pathway.length>0 && hear.length>0;
        }
    }
}
</script>
